import { Editor, Extension, Range } from '@tiptap/react';
import Suggestion, { SuggestionOptions } from '@tiptap/suggestion';

import { SlashMenuRendererProps } from './SlashMenuRenderer';

type SlashExtensionOptions = {
  suggestion: Omit<SuggestionOptions<SlashMenuRendererProps>, 'editor'> & {
    editor?: Editor;
  };
};

export const SlashCommand = Extension.create<SlashExtensionOptions>({
  name: 'slash',
  addOptions: {
    // The ts-ignore below is an for error in the Extension types from tiptap. Tiptap
    // Applies Partial to its defaultOptions type, however, this Partial is
    // not recursive, and forces the user to define a complete object if it
    // defines anything at all. This is incorrect.
    // @ts-ignore
    suggestion: {
      // we should override the character that triggers the autocomplete popup. By default it is '@'
      char: '/',
      // trigger the autocomplete (floating menu) popup at the start of a line only.
      startOfLine: true,
      command: ({
        editor,
        range,
        props,
      }: {
        editor: Editor;
        range: Range;
        props: SlashMenuRendererProps;
      }) => {
        // pass the editor and range to the suggestion command
        props.command?.({ editor, range, props });
      },
    },
  },

  // This handles registering the suggestion plugin with the editor.
  addProseMirrorPlugins() {
    const editor = this.options.suggestion.editor ?? this.editor;
    const { editor: _, ...params } = this.options.suggestion;
    return [
      Suggestion({
        editor,
        ...params,
      }),
    ];
  },
});
